import BoxImage from "@components/BoxImage";
import BoxUrlOrFile from "@components/BoxUrlOrFile";
import BoxVideoThumbnail from "@components/BoxVideoThumbnail";
import ButtonContainer from "@components/ButtonContainer";
import Select from "@components/EasyDev/form/Select";
import FileUpload from "@components/Shared/FileUpload";
import FormDatePickerField from "@components/Shared/FormDatePickerField";
import FormTextField from "@components/Shared/FormTextField";
import { GalleryType } from "@enums/galleryType";
import { galleryTypeOptions } from "@helpers/createMedia.helper";
import { timestampToDate } from "@helpers/dates.format";
import { getInitialSelectedOption } from "@helpers/selectOptions.helper";
import { isYoutubeUrl } from "@helpers/youtube.helper";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement, useState } from "react";
import { Field, useFormState } from "react-final-form";
import { TCreateMediaDto } from "types/Media/createMediaDto";
import styles from "./ModifyMedia.module.scss";

interface IModifyForm extends IFormProps {
  data: TCreateMediaDto;
}

const ModifyForm = ({ handleSubmit, data }: IModifyForm): ReactElement => {
  const { values } = useFormState({
    subscription: { values: true, pristine: true },
  });
  const [date] = useState(timestampToDate(data?.date));

  const currentType = values?.type?.value || data?.type?.toLowerCase();

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">Title</span>
        <div className="form__form-group-field">
          <Field
            name="title"
            component={FormTextField}
            isAboveError
            placeholder="Enter a Title"
            initialValue={data?.title}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Date</span>
        <div className="form__form-group-field">
          <Field
            name="date"
            component={FormDatePickerField}
            placeholder="Enter a Date"
            isAboveError
            initialValue={date}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Type</span>
        <div className="form__form-group-field">
          <Field
            name="type"
            component={Select}
            placeholde="Enter Gallery Type"
            isAboveError
            options={galleryTypeOptions}
            initialValue={getInitialSelectedOption(
              galleryTypeOptions,
              data?.type.toLowerCase()
            )}
          />
        </div>
      </div>

      {currentType === GalleryType.Single && data?.gallery && (
        <>
          <BoxUrlOrFile
            title="Gallery"
            formFieldName="gallery"
            initialValueUrl={data?.gallery[0].mediaUrl}
            section="modify"
            initialData={data}
          />

          <div className={styles.gallery}>
            {data.gallery.map((item) =>
              item.mediaUrl.includes("mp4") ? (
                <BoxVideoThumbnail
                  key={item.mediaUrl}
                  url={item.mediaUrl}
                  isPreview
                />
              ) : isYoutubeUrl(item.mediaUrl) ? (
                <BoxVideoThumbnail
                  key={item.mediaUrl}
                  url={item.mediaUrl}
                  isPreview
                  isYoutube
                />
              ) : (
                <BoxImage key={item.mediaUrl} urlImage={item.mediaUrl} />
              )
            )}
          </div>
        </>
      )}

      {currentType !== GalleryType.Single && (
        <FileUpload
          title="Gallery"
          isSingle={currentType === GalleryType.Single}
          initialData={data}
        />
      )}

      <ButtonContainer />
    </form>
  );
};

export default ModifyForm;
